import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Config } from "../models/config";
import { firstValueFrom, take } from "rxjs";

@Injectable()
export class ConfigService {

	public contentEndpoint: string;
	public playlistEndpoint: string;
	public accountEndpoint: string;
	public myndbandaEndpoint: string;
	public sentryDsn: string;
	public environment: string;

	constructor(private http: HttpClient) { }

	async load(): Promise<Config> {

		return new Promise<Config>(async (resolve, reject) => {

			const config = await firstValueFrom(this.http.get<Config>('./assets/config.json'));

			Object.assign(this, config);
			resolve(config);
		});

	}
}